// firebaseTokenService.js
import { messaging, db } from "./FirebaseConfig";
import { getToken } from "firebase/messaging";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { REACT_APP_FIREBASE_VAPID_KEY } from "../config/config";

export const SaveUserToken = async (userId, userName,type) => {

  // console.log(userId,userName)
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    const token = await getToken(messaging, { vapidKey: REACT_APP_FIREBASE_VAPID_KEY });
    if (!token) return null;

    const userData = {
      name: userName,
      partnerType: type,
      token,
      updatedAt: serverTimestamp(), // yaha server timestamp add kiya
    };

    // Store in Firestore using unique userId
    await setDoc(doc(db, "user-token", userId), userData, { merge: true }); 
    // merge:true ensures existing data is not overwritten completely
    // console.log("Token saved/updated for user:", userId);
    return token;
  } catch (err) {
    console.error("Error saving FCM token:", err);
    return null;
  }
};